import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Subtitle = styled.div(
  ({theme}) => css`
    color: ${theme.colors.contentInversePrimary};
    ${theme.elevations.small};
  `
);
